// extracted by mini-css-extract-plugin
export var phone = "_52-0";